export default "__VITE_ASSET__44585294__"